export default __webpack_public_path__ + "static/media/starbucks.97437064.png";